/** What each surface is called, in the cog's menu and wherever it is being edited. */
export const SURFACE_LABELS = {
  list: 'COLUMNS',
  detail: 'DETAIL',
  filters: 'FILTERS',
  sorting: 'SORTING',
  search: 'SEARCH_BAR',
};

/** The surfaces edited on the page itself rather than in a dialog. */
export const IN_PLACE_SURFACES = ['detail'];

/**
 * Whether a surface is arranged on the page it draws.
 *
 * @param {String} surface - A surface name.
 *
 * @returns {Boolean}
 */
export const isInPlaceSurface = (surface) =>
  IN_PLACE_SURFACES.includes(surface);
